<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
		components: {}
	}
</script>

<style lang="scss">
@import './assets/style/global.css';

#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	// position: absolute;
	height: 100%;
	width: 100%;
	overflow-x: auto;
	overflow-y: hidden;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    background-clip: content-box;
    border: 2px solid transparent;
  }
}

.el-message {
	z-index: 99999999 !important;
}

.el-scrollbar__thumb {
	background-color: #A0A8AF !important;
}

.el-dialog {
	border-radius: 8px !important;
	overflow: hidden !important;
}

.el-dialog__header {
	background-color: #fff !important;
	color: #b78e6c;
}

.el-dialog__title {
	color: #b78e6c !important;
}

.el-dialog__close {
	color: b78e6c !important;
	font-size: 20px;
}

// .el-checkbox__inner {
// 	border-radius: 50% !important;
// }

// .el-input__inner {
// 	border-radius: 5px !important;
// 	border: #888 1px solid !important;
// }

// .el-textarea__inner{
// 	border-radius: 5px !important;
// 	border: #888 1px solid !important;
// }

// .el-icon-search {
// 	color:#888 !important;
// }

// .el-button--primary {
//   background-color: #b78e6c !important;
// 	border-color: #b78e6c !important;
// }
// .el-button:focus, .el-button:hover{
// 	color: #606266 !important;
// 	// background: #fff !important;
// 	// border-color: #DCDFE6 !important;
// }

// .el-button--success {
// 	background-color: #4cae1b !important;
// 	border-color: #4cae1b !important;
// }
// .el-button--danger {
// 	background-color: #ea4949 !important;
// 	border-color: #ea4949 !important;
// }

.el-button {
	padding: 8px 15px !important;
}

.el-checkbox {
	display: flex;
	align-items: center;

	//修改选中框的大小
	.el-checkbox__inner {
		width: 20px;
		height: 20px;

		//修改选中框中的对勾的大小和位置
		&::after {
			height: 12px;
			left: 7px;
		}
	}

	//修改点击文字颜色不变
	.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #333333;
	}

	.el-checkbox__label {
		line-height: 20px;
		padding-left: 8px;
	}
}
</style>